import { Route, Routes } from "react-router-dom"
import './App.css';
import Home from "./pages/Home";
import Travel from "./pages/Travel";
import Food from "./pages/Food";
import Contact from "./pages/Contact";
import Blog from "./pages/Blog";
import About from "./pages/About";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/food" element={<Food />} />
      <Route path="/travel" element={<Travel />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/contact" element={<Contact />} />
    </Routes>
    
  );
}

export default App;
